const objectAddToString = (obj: { [key: string]: boolean }) => {
  return Object.keys(obj)
    .reduce((keyString, key) => {
      const value = obj[key];
      return value ? `${keyString} ${key}` : keyString;
    }, '')
    .trim();
};

export const classnames = (...args: any[]): string => {
  const classNameString = args.reduce((classString, arg) => {
    switch (typeof arg) {
      case 'string':
        return `${classString} ${arg}`;
      case 'object':
        const objectClassStrings = objectAddToString(arg);
        return !!objectClassStrings ? `${classString} ${objectClassStrings}` : classString;
      default:
        return classString;
    }
  }, '');

  return classNameString.trim();
};
